import { auditReports } from '@mi-front/api-clients';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface Props {
  result: auditReports.GipReportResultDto | auditReports.GipAltReportResultDto;
}

export const GipReportStatsSummary = ({ result }: Props) => {
  const { meta, matchedSchedules, unmatchedSchedules, unprocessedSchedules, futureSchedules } =
    result;
  const totalSchedules = matchedSchedules.length + unmatchedSchedules.length;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          <FormattedMessage id="audit.gip.report.summary" defaultMessage="Resumen" />
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={2}>
            <Box textAlign="center">
              <Typography variant="h4" color="primary">
                {totalSchedules}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage
                  id="audit.gip.report.totalSchedules"
                  defaultMessage="Total de schedules"
                />
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box textAlign="center">
              <Typography variant="h4" color="success.main">
                {matchedSchedules.length}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage id="audit.gip.report.withMatch" defaultMessage="Con match" />
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box textAlign="center">
              <Typography variant="h4" color="warning.main">
                {unmatchedSchedules.length}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage id="audit.gip.report.withoutMatch" defaultMessage="Sin match" />
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box textAlign="center">
              <Typography variant="h4" color="info.main">
                {meta.matchedEfficiency ? Math.floor(meta.matchedEfficiency) : 0}%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage id="audit.gip.report.efficiency" defaultMessage="Eficiencia" />
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box textAlign="center">
              <Typography variant="h4" color="#777">
                {meta.processedProgress ? Math.floor(meta.processedProgress) : 0}%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage
                  id="audit.gip.report.scheduleProgress"
                  defaultMessage="Progreso de schedules"
                />
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box textAlign="center">
              <Typography variant="h4" color="error.main">
                {unprocessedSchedules.length + futureSchedules.length}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <FormattedMessage id="audit.gip.report.pending" defaultMessage="Pendientes" />
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
